import React, {useEffect, useState} from 'react';
import {
    Alert,
    Button,
    Checkbox,
    Divider,
    Form,
    Input,
    message,
    Progress,
    Radio,
    Select,
    Skeleton,
    Spin,
    Upload
} from "antd";
import {useMutation, useQuery} from "react-query";
import {useParams} from "react-router-dom";
import parsePhoneNumber from "libphonenumber-js";
import {DeleteFilled, InboxOutlined, UploadOutlined} from "@ant-design/icons";
import {sortableContainer, sortableElement, SortableHandle} from 'react-sortable-hoc';
import {arrayMoveImmutable} from 'array-move';
import {GetApp, UpdateApp} from "../../../../../api/apps";
import {GetDictsConsole} from "../../../../../api/console";
import axios from "axios";
import Config from "../../../../../config";


export const StoreController = (props) => {
    const params = useParams();
    const {developer_id, app_id} = params;
    const [form] = Form.useForm();
    const [btnDisabled, setBtnDisabled] = useState(true);
    const [appMedia, setAppMedia] = useState([]);
    let mediaStore = '';

    const UpdateMediaMutation = useMutation(
        (data) => UpdateApp(developer_id, app_id, data),
        {
            onSuccess: (res, vars) => {
                setBtnDisabled(true);
                message.success(`Приложение успешно обновлено`)
            },
            onError: (e) => {
                console.error(`[UpdateMediaMutation] `, e.response);
                message.error(e?.response?.data?.message || "Во время запроса произошла ошибка");
            }
        }
    )

    const App = useQuery(
        ['app', developer_id, app_id],
        () => GetApp(developer_id, app_id),
        {
            refetchOnWindowFocus: false,
            retry: 1,
            onError: (e) => {
                message.error(e?.response?.data?.message || "Во время запроса произошла ошибка");
            }
        }
    );

    useEffect(() => {
        if (App?.data?.app && App?.data?.app?.media) {
            mediaStore = JSON.stringify(App?.data?.app?.media || []);
            setAppMedia(App?.data?.app?.media || [])
        }
    }, [App?.data?.app])

    useEffect(() => {
        if (appMedia.length > 0) {
            setBtnDisabled(b => {
                return mediaStore === JSON.stringify(appMedia)
            });
        }
    }, [appMedia])


    const onFormChange = () => {
        setBtnDisabled(false);
    }

    const AppData = App?.data?.app || {};
    return (
        <Spin spinning={App.isLoading}>
            {App.isSuccess === false && <Skeleton/>}
            {App.isSuccess === true && (
                <Form
                    scrollToFirstError
                    name={`store`}
                    layout={`vertical`}
                    form={form}
                    onFieldsChange={onFormChange}
                    onFinish={(values) => {
                        UpdateMediaMutation.mutate({...values, ...{media: appMedia.map(i => i.hash)}});
                    }}
                    initialValues={{
                        title: AppData?.title || "",
                        short_description: AppData?.short_description || "",
                        description: AppData?.description || "",

                        moderator_info: AppData?.moderator?.moderator_info || "",
                        moderator_auth: AppData?.moderator?.moderator_auth || false,

                        email: AppData?.contacts?.email || "",
                        phone: AppData?.contacts?.phone || "",
                        website: AppData?.contacts?.website || "",

                        type: AppData?.type || "",
                        age_restrictions: AppData?.age_restrictions || "",
                        privacy_url: AppData?.privacy_url || "",
                        paid_options: AppData?.paid_options || "",
                        video_url: AppData?.video_url || "",
                        category: AppData?.category || null,
                        ads: AppData?.ads || false,
                        user_data_ru: AppData?.user_data_ru || false,
                    }}
                >
                    <div className={`dev__layout store--layout`}>
                        <div className={`dev__layout--header`}>
                            <div className="header__info">
                                <h1>Описание приложения</h1>
                            </div>
                        </div>

                        <Alert
                            className={`store--alert`}
                            type={`info`}
                            description={`Заполните данные о Вашем приложении. Эта информация будет полезна пользователям при принятии решения об установке, поэтому относитесь внимательно к процессу внесения информации.`}
                        />

                        <Divider>Основное описание</Divider>
                        <MainDescription/>

                        <Divider>Категория и тип</Divider>
                        <CategoryAndType
                            app={App?.data?.app}
                            form={form}
                        />

                        <Divider>Контактная информация</Divider>
                        <ContactsInfo/>

                        <Divider>Изображения и видео</Divider>
                        <MediaInfo
                            developer_id={developer_id}
                            app_id={app_id}
                            appMedia={appMedia}
                            setAppMedia={setAppMedia}
                        />
                        <Divider>Параметры приложения</Divider>
                        <PrivacyAndPaid
                            app={App?.data?.app}
                        />
                        <Divider>Информация для модераторов</Divider>
                        <ModeratorInfo/>
                        <div className={`store--button__full`}>
                            <Button type={`link`} disabled={btnDisabled} onClick={() => window.location.reload()}>Отменить
                                изменения</Button>
                            <Button type={`primary`} htmlType={`submit`} disabled={btnDisabled}
                                    loading={UpdateMediaMutation.isLoading}>Сохранить</Button>
                        </div>
                    </div>
                </Form>
            )}
        </Spin>
    );
}

const MainDescription = () => {
    return (
        <div className={`store--form`}>
            <Form.Item
                label={`Название приложения`}
                extra={`Будет отображаться в магазине в виде заголовка`}
                name={`title`}
                rules={[
                    {required: true, message: `Укажите заголовок приложения`}
                ]}
            >
                <Input
                    maxLength={54}
                    showCount
                />
            </Form.Item>
            <Form.Item
                label={`Короткое описание приложения`}
                extra={`Будет отображаться на странице приложения`}
                name={`short_description`}
                rules={[
                    {required: true, message: `Укажите короткое описание приложения`}
                ]}
            >
                <Input
                    maxLength={80}
                    showCount
                />
            </Form.Item>
            <Form.Item
                label={`Полное описание приложения`}
                name={`description`}
                extra={`Будет отображаться, когда пользователь нажмет «Подробнее» на странице приложения`}
                rules={[
                    {required: true, message: `Укажите описание приложения`}
                ]}
            >
                <Input.TextArea
                    maxLength={8000}
                    showCount
                />
            </Form.Item>
        </div>
    );
}

const CategoryAndType = ({app, form}) => {
    const [appType, setAppType] = useState(app.type || false);
    const {data, isLoading} = useQuery('console_dicts', GetDictsConsole)
    return (
        <div className={`store--form`}>
            <Form.Item
                label={`Тип приложения`}
                name={`type`}
                rules={[{required: true, message: `Выберите тип приложения`}]}
            >
                <Radio.Group
                    onChange={(e) => {
                        setAppType(e.target.value);
                        form.setFieldsValue({
                            category_id: null,
                        });
                    }}
                    value={appType}
                    >
                        {(appType === 'application' || appType === 'game' || appType === false) && (
                            <>
                                <Radio.Button value="application">Приложение</Radio.Button>
                                <Radio.Button value="game">Игра</Radio.Button>
                            </>
                        )}
                        {appType === 'linux' && (
                            <Radio.Button value="linux">Linux</Radio.Button>
                        )}
                    </Radio.Group>
                </Form.Item>
            <Form.Item
                label={`Категория`}
                name={`category`}

                rules={[{required: true, message: `Выберите категорию приложения`}]}
            >
                <Select
                    showSearch
                    optionFilterProp="children"
                    loading={isLoading}
                    placeholder={`Выберите наиболее подходящий раздел, к которому Вы можете отнести разработку`}
                    filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                >
                    {(appType === false) && <Select.Option>Выберите категорию приложения</Select.Option>}
                    {(appType !== false && data?.categories) && data?.categories.map(i => {
                            if (i.type !== appType) {
                                return null
                            }
                            return <Select.Option value={i.id}>{i.title}</Select.Option>
                        }
                    )}
                </Select>
            </Form.Item>
        </div>
    )
}

const ModeratorInfo = ({app, form}) => {
    return (
        <div className={`store--form moderator__info`}>
            <Form.Item label={`Для использования приложения требуется авторизация`} name={`moderator_auth`}
                       valuePropName={`checked`} extra={`Активируйте этот пункт, если для работы с приложением нужно авторизоваться`}>
                <Checkbox value={true}/>
            </Form.Item>
            <Form.Item label={`Информация для авторизации`} name={`moderator_info`} extra={`Укажите данные, которые необходимы модераторам для авторизации, например Логин, Пароль и другие данные`}>
                <Input.TextArea
                    maxLength={300}
                    showCount
                />
            </Form.Item>
        </div>
    )
}

const PrivacyAndPaid = ({app, form}) => {
    const {data, isLoading} = useQuery('console_dicts', GetDictsConsole)
    return (
        <div className={`store--form`}>
            <Form.Item style={{display: 'none'}} label={`Покупки в приложении`}
                       extra={`Укажите, какой тип контента можно покупать в вашем приложении`} name={`paid_options`}>
                <Checkbox.Group>
                    {data?.paid_options && data?.paid_options.map(i => {
                        return <Checkbox value={i.id}>{i.title}</Checkbox>
                    })}
                </Checkbox.Group>
            </Form.Item>
            <Form.Item valuePropName={`checked`} label={`Есть реклама`} name={`ads`}>
                <Checkbox/>
            </Form.Item>
            <Form.Item label={`Возрастной рейтинг`} name={`age_restrictions`}
                       rules={[{required: true, message: `Укажите возрастной рейтинг`}]}>
                <Select placeholder={`Выберите значение`} loading={isLoading}>
                    {data?.ages && data?.ages.map(i => {
                        return <Select.Option value={i.id}>{i.title}</Select.Option>
                    })}
                </Select>
            </Form.Item>
            <Form.Item
                label={`Ссылка на политику конфиденциальности`}
                name={`privacy_url`}
                rules={[
                    {required: true, message: 'Укажите ссылку на политику конфиденциальности'},
                    {type: 'url', message: `Введена не корректная ссылка, ссылка должна начинаться с http/https`}
                ]}
            >
                <Input placeholder={`Введите полный адрес, начиная с http/https`}/>
            </Form.Item>
            <Form.Item extra={`Активируйте этот пункт, если данные пользователей из России хранятся на серверах в России`}
                       valuePropName={`checked`} label={`Данные пользователей хранятся в России`}
                       name={`user_data_ru`}>
                <Checkbox value={true}/>
            </Form.Item>
        </div>
    );
}

const ContactsInfo = () => {
    return (
        <div className={`store--form`}>
            <Form.Item
                label={`Email`}
                name={`email`}
                rules={[
                    {required: true, message: 'Укажите ваш почтовый адрес для поддержки пользователей'},
                    {type: 'email', message: 'Укажите корректный почтовый адрес'},
                ]}
            >
                <Input type={`email`} placeholder={`Укажите почту, на которую будут писать пользователи в случае возникновения проблем`}/>
            </Form.Item>
            <Form.Item
                label={`Телефон`}
                name={`phone`}
                rules={[
                    {
                        validator: async (_, phone = '') => {
                            // const { short, phone, code } = names;
                            const phoneNumber = parsePhoneNumber(phone);
                            if (phone !== '') {
                                if ((!phoneNumber || !phoneNumber.isValid())) {
                                    return Promise.reject(new Error('Введен не корректный номер телефона'));
                                }
                            }
                        }
                    },
                ]}
            >
                <Input
                    placeholder={`Укажите телефон техподдержки, если он есть, в формате +7`}
                />
            </Form.Item>
            <Form.Item
                label={`Ссылка на сайт`}
                name={`website`}
                rules={[
                    {type: 'url', message: `Введена не корректная ссылка, ссылка должна начинаться с http/https`}
                ]}
            >
                <Input placeholder={`Укажите полный адрес Вашего сайта, начиная с http/https`}/>
            </Form.Item>
        </div>
    )
}

const MediaInfo = (props) => {
    const {app_id, developer_id, appMedia, setAppMedia} = props;
    return (
        <div className={`store--form`}>
            <Form.Item
                label={`Ссылка на видео`}
                name={`video_url`}
                extra={`Поддерживаются ссылки на видеохостинге ВКонтакте и RuTube`}
                rules={[
                    {type: 'url', message: `Введена не корректная ссылка`},
                    {
                        validator: async (_, path = '') => {
                            try {
                                if (!Config.VALIDATE_VIDEO_SOURCE(path)) {
                                    return Promise.reject(new Error('Укажите ссылку на видеохостинге ВКонтакте или RuTube'));
                                }
                            } catch (e) {
                                console.error(`[URL]`, e);
                            }

                        }
                    }
                ]}
            >
                <Input/>
            </Form.Item>
            <MediaUpload
                title={`Иконка приложения`}
                extra={`Поддерживаются JPG/PNG, максимальный размер 1 МБ, размер изображения должен быть 512x512`}
                accept={'.jpg,.jpeg,.png'}
                acceptTypes={['image/jpg', 'image/jpeg', 'image/png']}
                maxSize={1048576}
                mediaCount={1}
                mediaType={'icon'}
                app_id={app_id}
                developer_id={developer_id}
                appMedia={appMedia}
                setAppMedia={setAppMedia}
            />
            <MediaUpload
                title={`Скриншоты версии для телефона`}
                accept={'.jpg,.jpeg,.png'}
                acceptTypes={['image/jpg', 'image/jpeg', 'image/png']}
                extra={`Загрузите от 2 до 8 скриншотов. Скриншоты должны быть в формате PNG/JPG. Соотношение сторон 16:9 (например, 1280x720, 1366x768, 1600x900, 1920x1080) или 9:16, максимальный размер одного файла 5 МБ.`}
                maxSize={5242880}
                mediaCount={8}
                mediaType={'phone'}
                sort={true}
                app_id={app_id}
                developer_id={developer_id}
                appMedia={appMedia}
                setAppMedia={setAppMedia}
            />
        </div>
    );
}

export const MediaUpload = (props) => {
    const {
        app_id,
        developer_id,
        title = '',
        extra = '',
        mediaType = '',
        acceptTypes = [],
        accept = '',
        maxSize = 1,
        mediaCount = 1,
        sort = false,
        appMedia = [],
        setAppMedia,
    } = props;
    const [isLoading, setIsLoading] = useState(appMedia.filter(i => i.type === mediaType).length > 0);
    const [err, setError] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState(false);
    window.MediaUUIDS = window.MediaUUIDS || [];

    useEffect(() => {
        setIsLoading(appMedia.filter(i => i.type === mediaType).length > 0);
    }, [appMedia])

    // const queryFiles = useQuery(
    //     ['media_list', developer_id, app_id],
    //     () => MediaApp(developer_id, app_id)
    // );
    //
    // useEffect(() => {
    //     if (queryFiles.data && queryFiles.data.list) {
    //         let items = queryFiles.data?.list.filter(i => i.type === mediaType);
    //         if (items.length > 0) {
    //             setIsLoading(true);
    //             setAppFiles(items.map(i => i.hash));
    //         }
    //     }
    // }, [queryFiles.data]);

    const buildFiles = (uploadedFiles) => {
        let files = [].slice.call(uploadedFiles || []);
        // фильтруем по размеру
        files = files.filter(i => {
            if (window.MediaUUIDS.indexOf(i.uid) + 1 === 0) {
                window.MediaUUIDS.push(i.uid);
            } else {
                return false;
            }
            return i.size <= maxSize;
        });

        // фильтруем по типу
        if (acceptTypes.length > 0) {
            files = files.filter(i => acceptTypes.indexOf(i.type) + 1 > 0);
        }


        // отрезаем ненужные
        if (mediaCount > 0 && files.length > 0) {
            files = files.slice(0, mediaCount);
        }

        if (files.length === 0) {
            // message.error(`Медиа не подходит под требования`)
        } else {
            setIsLoading(true)
            setUploadedFiles(files);
        }
    }

    const resetUploading = () => {
        setIsLoading(false)
        setUploadedFiles([]);
    }

    const onMediaUploadFinish = (uid) => {
        setUploadedFiles(files => {
            return files.filter(i => {
                return i.uid !== uid
            });
        });
    }

    const uploaderProps = {
        accept,
        multiple: mediaCount > 1,
        showUploadList: false,
        beforeUpload: (file) => {
            return false
        },
        onDrop: (e) => {
            console.log(e);
            if (e && e?.dataTransfer && e?.dataTransfer.files) {

                // buildFiles(e?.dataTransfer.files);
            }
        },
        onChange: ({fileList}) => {
            buildFiles(fileList);
        },
    };


    return (
        <div className={`store--media__upload`}>
            <div className="media__title">{title}</div>
            {isLoading === false && (
                <div className="media__container">
                    <Upload.Dragger {...uploaderProps}>
                        <p className="ant-upload-drag-icon">
                            <InboxOutlined/>
                        </p>
                        <p className="ant-upload-text">Кликните или перетащите файл на область для загрузки
                            изображения</p>
                    </Upload.Dragger>
                </div>
            )}
            {isLoading === true && (
                <MediaList
                    maxCount={mediaCount}
                    uploadList={uploadedFiles}
                    app_id={app_id}
                    developer_id={developer_id}
                    media_type={mediaType}
                    resetUploading={resetUploading}
                    buildFiles={buildFiles}
                    uploaderProps={uploaderProps}
                    onMediaUploadFinish={onMediaUploadFinish}
                    setAppMedia={setAppMedia}
                    appMedia={appMedia}
                />
            )}

            {extra && <div className={`media__extra`}>{extra}</div>}
            {err && <div className={`media__error`}>{err}</div>}
        </div>
    );
}

const MediaList = (props) => {
    const {
        appFiles,
        media_type,
        app_id,
        developer_id,
        maxCount = 1,
        uploadList = [],
        filesList = [],
        resetUploading,
        onMediaUploadFinish,
        uploaderProps,
        setAppMedia,
        appMedia = [],
    } = props;
    const [mediaUploadList, setMediaUploadList] = useState(uploadList || []);

    // const DeleteMediaMutation = useMutation(
    //     (data) => MediaDelete(developer_id, app_id, data),
    //     {
    //         onError: (e) => {
    //             console.error(`[DeleteMediaMutation] `, e.response);
    //             message.error(e?.response?.data?.message || "Во время запроса произошла ошибка");
    //         }
    //     }
    // )
    //
    // const UpdateMediaSortMutation = useMutation(
    //     (data) => MediaSort(developer_id, app_id, data),
    //     {
    //         onError: (e) => {
    //             console.error(`[UpdateMediaSortMutation] `, e.response);
    //             message.error(e?.response?.data?.message || "Во время запроса произошла ошибка");
    //         }
    //     }
    // )

    const updateMediaUploaded = (mediaHash, uuid) => {
        setMediaUploadList(mediaList => mediaList.filter(i => i.uid !== uuid));
        setAppMedia(mediaFilesList => {
            return [...mediaFilesList, ...[{hash: mediaHash, type: media_type, sort: 99}]];
        });
    }

    useEffect(() => {
        setMediaUploadList(uploadList);
    }, [uploadList]);


    const onSortEnd = ({oldIndex, newIndex, collection}) => {
        setAppMedia(mediaList => {
            const iconExists = mediaList.filter(i => i.type === 'icon');
            if (iconExists.length > 0) {
                mediaList = arrayMoveImmutable(mediaList, oldIndex + 1, newIndex + 1)
            } else {
                mediaList = arrayMoveImmutable(mediaList, oldIndex, newIndex)
            }
            return mediaList;
        })
    }


    const onRemoveElement = (hash = '') => {
        setAppMedia(mediaFilesList => {
            let resultList = mediaFilesList.filter(i => i.hash !== hash);
            if (resultList.length === 0) {
                resetUploading();
            }
            return resultList;
        });
    }

    const totalUploaded = appMedia.filter(i => i.type === media_type).length;

    return (
        <div className={`media--block__sortable`}>
            {appMedia.length === 1 && (
                <div className={`media__sortable ${media_type}`}>
                    {appMedia.filter(i => i.type === media_type).map((i, index) => {
                        return (
                            <MediaElement
                                shouldUseDragHandle={false}
                                index={index}
                                hash={i.hash}
                                key={i.hash}
                                type={media_type}
                                onRemoveElement={onRemoveElement}
                            />
                        );
                    })}
                </div>
            )}
            {appMedia.length > 1 && (
                <MediaSortableList
                    shouldUseDragHandle={true}
                    useDragHandle
                    onSortEnd={onSortEnd}
                    media_type={media_type}
                    axis={'xy'}
                    helperClass={`dnd-hoc__media`}
                    items={appMedia}
                    onRemoveElement={onRemoveElement}
                />
            )}
            {mediaUploadList.length > 0 && (
                <div className={`media__uploaded`}>
                    {mediaUploadList.map(i => (
                        <UploadMedia
                            file={i}
                            key={i.uid}
                            app_id={app_id}
                            developer_id={developer_id}
                            media_type={media_type}
                            onUpload={updateMediaUploaded}
                            resetUploading={resetUploading}
                            maxCount={maxCount}
                            uploadedList={mediaUploadList}
                            onMediaUploadFinish={onMediaUploadFinish}
                        />
                    ))}
                </div>
            )}
            <div className="block__actions">
                {maxCount > 1 && (<div className={`actions__count`}>{totalUploaded}/{maxCount}</div>)}
                {maxCount > 1 && (<div className="actions__button">
                    <Upload {...uploaderProps} disabled={maxCount === totalUploaded}>
                        <Button disabled={maxCount === totalUploaded} icon={<UploadOutlined/>}>Добавить</Button>
                    </Upload>
                </div>)}
            </div>
        </div>
    );
}

const UploadMedia = (props) => {
    const {
        file,
        media_type,
        developer_id,
        app_id,
        onUpload,
        resetUploading,
        uploadedList,
        onMediaUploadFinish
    } = props;
    const [progress, setProgress] = useState(0);
    const [isError, setIsError] = useState(false)
    const [isFinished, setIsFinished] = useState(false);

    useEffect(() => {
        let formData = new FormData();
        window.UploadedUUID = window.UploadedUUID || [];
        window.UploadedUUID.push(file.uid);
        formData.append("file", file.originFileObj, file.name);
        axios.post(`${Config.API}media/${developer_id}/${app_id}/${media_type}`, formData, {
            withCredentials: true,
            onUploadProgress: progressEvent => {
                let progress = ((progressEvent.loaded / progressEvent.total) * 100).toFixed(2)
                setProgress(progress);
            }
        }).then(res => {
            setIsFinished(true);
            setProgress(100);
            // update info
            setTimeout(() => {
                onUpload(res.data?.media_hash, file.uid);
                onMediaUploadFinish(file.uid);
            }, 200);
        }).catch(e => {
            setProgress(0);
            setIsError(true);
            message.error(e?.response?.data?.message || "Во время запроса произошла ошибка");
            if (uploadedList.length === 1) {
                resetUploading();
            }
        });
    }, [file]);


    let progressProps = {
        type: "circle",
        percent: progress,
        width: 80,
    };

    if (isError) {
        progressProps.status = "exception"
    }

    return (
        <div className={`upload__media ${media_type}`}>
            <Progress {...progressProps} />
        </div>
    );
}

const MediaSortableList = sortableContainer(props => {
    const {items, media_type, onRemoveElement, ...restProps} = props;
    return (
        <div className={`media__sortable ${media_type}`}>
            {items.filter(i => i.type === media_type).map((i, index) => {
                return (
                    <SortableItem
                        index={index}
                        hash={i.hash}
                        key={i.hash}
                        type={media_type}
                        onRemoveElement={onRemoveElement}
                        {...restProps}
                    />
                );
            })}
        </div>
    );
});

const MediaElement = ({type, shouldUseDragHandle, hash, onRemoveElement}) => {
    return (
        <div className={`media sortable_media media_${type}`}>
            <div className="media__wrapper">
                <Button type={`danger`} icon={<DeleteFilled/>} shape={`circle`} onClick={() => onRemoveElement(hash)}/>
                <img src={`${Config.MEDIA.IMAGES}/${hash}/original`} alt={hash}/>
                {shouldUseDragHandle && <Handle/>}
            </div>
        </div>
    )
}

const SortableItem = sortableElement(props => {
    const {shouldUseDragHandle, hash, type, onRemoveElement} = props;
    return (
        <MediaElement
            shouldUseDragHandle={shouldUseDragHandle}
            hash={hash}
            type={type}
            onRemoveElement={onRemoveElement}
        />
    )
});

const Handle = SortableHandle(({tabIndex}) => (
    <div className={`media__drag--handle`}/>
));


export default StoreController;